
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 21.763","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.644 9.86S31.325 0 20 0C8.675 0 .355 9.86.355 9.86c-.474.561-.474 1.48 0 2.043 0 0 8.32 9.86 19.645 9.86s19.644-9.86 19.644-9.86c.474-.562.474-1.482 0-2.044zM20 19.257a8.377 8.377 0 110-16.754 8.377 8.377 0 010 16.754z"}}),_c('path',{attrs:{"d":"M23.95 9.128a1.783 1.783 0 01-1.629-2.504 4.849 4.849 0 102.167 2.422c-.17.053-.35.082-.537.082z"}})])
          )
        }
      }
    